import { Route } from '@angular/router';
import { authGuard, designBarGuard } from '@dental-ui/auth';
import {
  CAD_AUTOBAR_ROUTE_PATH,
  CAD_CROWN_VIEWER_ROUTE_PATH,
} from '@dental-ui/shared/consts';

export const appRoutes: Route[] = [
  {
    path: '',
    canActivate: [authGuard, designBarGuard],
    loadComponent: () => import('@dental-ui/cad-main').then(m => m.MainComponent)
  },
  {
    path: CAD_AUTOBAR_ROUTE_PATH,
    canActivate: [authGuard, designBarGuard],
    loadComponent: () => import('@dental-ui/cad-viewer').then(m => m.BarViewerComponent)
  },
  // Legacy deep links (lab workorder / bookmarks)
  {
    path: 'bar-designer',
    redirectTo: CAD_AUTOBAR_ROUTE_PATH,
    pathMatch: 'full'
  },
  {
    path: 'bar-viewer',
    redirectTo: CAD_AUTOBAR_ROUTE_PATH,
    pathMatch: 'full'
  },
  {
    path: CAD_CROWN_VIEWER_ROUTE_PATH,
    canActivate: [authGuard, designBarGuard],
    loadComponent: () => import('@dental-ui/cad-viewer').then(m => m.CrownViewerComponent)
  },
  {
    // Share links stay open without a Designer seat (view-only handoff).
    path: 'shared-designproject',
    loadComponent: () => import('@dental-ui/cad-viewer').then(m => m.SharedDesignprojectComponent)
  },
  {
    path: 'main',
    redirectTo: '',
    pathMatch: 'full'
  }
];
